import request from "../../utils/request";

const baseUrl = "/api/tableau";

export default {
    namespaced: true,
    state: {},
    getters: {},
    actions: {
        trusted(context, { config = {} }) {
            return request.post(`${baseUrl}/trusted`, { ...config });
        },
    },
    mutations: {},
};
